module.exports = __webpack_public_path__ + "img/class-body.afe0f564.png";